// Shared HCC France navigation and contact data (sourced from halalcorrect.fr).
export const LEGACY = "https://halalcorrect.fr/fr"
export const CONTACT = {
  name: "Halal Correct France",
  address: "274- -3 BATIMENT C ET D, 274 AVENUE DE LA MARNE",
  city: "59700 MARCQ-EN-BARŒUL, France",
  phone: "+33 6 61 14 27 87",
  phoneHref: "tel:+33661142787",
  email: "france@halalcorrect.com",
  scope: "Inspection et certification halal",
}
export const NAV = [
  {
    label: "À propos",
    items: [
      {
        label: "Qui sommes-nous ?",
        to: "/fr/about",
        desc: "Notre organisme et nos accréditations",
      },
      { label: "Structure de l’entreprise", to: "/fr/about/structure" },
      { label: "Vision, mission et valeurs", to: "/fr/about/vision" },
      {
        label: "Reconnaissance internationale",
        to: "/fr/about/international-approval",
      },
      { label: "Nos implantations", to: "/fr/about#implantations" },
    ],
  },
  {
    label: "Certification",
    items: [
      {
        label: "Notre certification",
        to: "/fr/certification/procedure",
      },
      { label: "Catégories de produits", to: "/fr/certification/categories" },
      {
        label: "Nos services",
        to: "/fr/certification/services",
        desc: "Diagnostic, audit et formation",
      },
    ],
  },
  {
    label: "Politiques",
    items: [
      { label: "Garantie halal", to: "/fr/policies/guarantee" },
      { label: "Politique d’intégrité", to: "/fr/policies/integrity" },
      { label: "Règlement tarifaire", to: "/fr/policies/fee-regulation" },
      {
        label: "Confidentialité, impartialité et droits des demandeurs",
        to: "/fr/policies/confidentiality-and-impartiality",
      },
    ],
  },
  {
    label: "Contact",
    items: [
      { label: "Faire une demande de certification", to: "/fr/contact/apply" },
      { label: "Demande d’informations", to: "/fr/contact/information" },
      { label: "Avis et réclamations", to: "/fr/contact/feedback" },
      { label: "Vérifier un certificat halal", to: "/fr/contact/check" },
      {
        label: "Export vers l’Arabie saoudite",
        to: "/fr/contact/saudi-application",
      },
    ],
  },
]
